/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

if (!customElements.get('steps-slider')) {
  const whenFlickityReady = () => {
    if (typeof Flickity === 'function') return Promise.resolve();
    return new Promise((resolve) => {
      document.querySelector('script[src*="vendor-v4"]').addEventListener('load', resolve, { once: true });
    });
  };

  customElements.define(
    'steps-slider',
    class StepsSlider extends HTMLElement {
      connectedCallback() {
        this.sliderEl = this.querySelector('.steps__slider');
        if (!this.sliderEl) return;

        this.setupReadMore();

        if (this.sliderEl.children.length <= 2) return;

        this.prevBtn = this.querySelector('[name="previous"]');
        this.nextBtn = this.querySelector('[name="next"]');

        whenFlickityReady().then(() => this.init());
      }

      setupReadMore() {
        const run = () => {
          let changed = false;
          this.querySelectorAll('.steps__card').forEach((card) => {
            const text = card.querySelector('.steps__text');
            const btn = card.querySelector('.steps__more');
            if (!text || !btn) return;
            if (text.scrollHeight - text.clientHeight > 1) {
              btn.hidden = false;
              changed = true;
              btn.addEventListener('click', () => {
                const expanded = text.classList.toggle('steps__text--expanded');
                btn.textContent = expanded ? btn.dataset.less : btn.dataset.more;
                if (this.flickity) this.flickity.resize();
              });
            }
          });
          if (changed && this.flickity) this.flickity.resize();
        };

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(run);
        } else {
          run();
        }
      }

      init() {
        this.flickity = new Flickity(this.sliderEl, {
          accessibility: false,
          rightToLeft: window.theme && theme.config ? theme.config.rtl : false,
          prevNextButtons: false,
          pageDots: false,
          cellAlign: 'left',
          contain: true,
          groupCells: true,
          wrapAround: false,
        });

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.flickity.previous());
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.flickity.next());

        this.flickity.on('select', () => this.updateArrows());
        this.flickity.on('ready', () => {
          this.flickity.resize();
          this.updateArrows();
        });
      }

      updateArrows() {
        if (!this.flickity) return;
        const { selectedIndex, slides } = this.flickity;
        if (this.prevBtn) this.prevBtn.disabled = selectedIndex === 0;
        if (this.nextBtn) this.nextBtn.disabled = selectedIndex >= slides.length - 1;
      }

      disconnectedCallback() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    }
  );
}
